module.exports = __webpack_public_path__ + "img/icon-untouched-18.6f13ecfa.svg";